export default {
  documentLanguage: 'English',
  defaultFromPhoneNumber: undefined,
};
